"use client";

import useAxiosPublicInstance from "@/hooks/useAxiosPublicInstance";

const CollaborationForm = () => {
  const axiosPublicInstance = useAxiosPublicInstance();

  async function onSubmit(e) {
    e.preventDefault();
    const name = e.target.name.value;
    const email = e.target.email.value;
    const message = e.target.message.value;

    const response = await axiosPublicInstance.post(
      "/websiteContents/contact/contact_message",
      { name, email, message }
    );

    if (response.status === 200) {
      e.target.name.value = "";
      e.target.email.value = "";
      e.target.message.value = "";
    }
  }
  return (
    <div className="mt-3 w-full max-w-2xl ">
      <div className="  w-full">
        <form onSubmit={onSubmit}>
          <div className="relative z-0 w-full mb-5 group ">
            <input
              type="name"
              name="name"
              id="floating_name"
              className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-b  border-[#dcdcdc] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 pt-7  focus:border-[#dcdcdc] peer pl-1 "
              placeholder=" "
            />
            <label
              for="floating_name"
              className="peer-focus:font-medium absolute text-sm text-[#dcdcdc] dark:text-gray-400 duration-300 transform -translate-y-2 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#dcdcdc] peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3  peer-focus:mt-1 pt-2 font-young-serif"
            >
              Full Name
            </label>
          </div>
          {/* Email */}
          <div className="relative z-0 w-full mb-5 group ">
            <input
              type="email"
              name="email"
              id="floating_email"
              className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-b border-[#dcdcdc] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 pt-7  focus:border-[#dcdcdc] peer pl-1 "
              placeholder=" "
            />
            <label
              for="floating_email"
              className="peer-focus:font-medium absolute text-sm text-[#dcdcdc] dark:text-gray-400 duration-300 transform -translate-y-2 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#dcdcdc] peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3  peer-focus:mt-1 pt-2 font-young-serif"
            >
              Email
            </label>
          </div>
          {/* Message */}
          <div className="relative z-0 w-full mb-5 group ">
            <input
              type="message"
              name="message"
              id="floating_message"
              className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-b border-[#dcdcdc] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 pt-7  focus:border-[#dcdcdc] peer pl-1 "
              placeholder=" "
            />
            <label
              for="floating_message"
              className="peer-focus:font-medium absolute text-sm text-[#dcdcdc] dark:text-gray-400 duration-300 transform -translate-y-2 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#dcdcdc] peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3  peer-focus:mt-1 pt-2 font-young-serif"
            >
              Message
            </label>
          </div>
          <div className="flex justify-start items-center">
            <button className="bg-[#0F62FE] mt-8 text-white hover:text-primary hover:bg-white duration-300 font-medium text-xs md:text-lg py-4 md:py-4 px-8 md:px-12 rounded-md ">
              Send Message
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CollaborationForm;
